import GamePiece from "./game-piece.js";

export default class GamePieceEmpty extends GamePiece {

    constructor(piece, gameBoard) {
        super(piece, gameBoard);
        this.isEmpty = true;
    }
    get isActive() { return false; }

    canMoveByDirection = () => false;
    canAttackByDirection = () => false;

    get allAvailablePiecesForAction() { return []; }
}
